<template>
  <div
    class="bg-white shadow border-b border-grey p-8 flex items-center rounded-lg hover:border-gray-300 cursor-pointer"
    @click="$router.push(href)"
  >
    <div
      class="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mr-6"
    >
      <img
        v-if="icon"
        :src="icon"
        alt="Service Icon"
        class="w-16 object-contain"
      />
    </div>

    <div class="flex-1 flex flex-col justify-center">
      <p class="font-semibold text-lg mb-1">{{ title }}</p>
      <p class="text-gray-600 text-sm mb-3">{{ description }}</p>
      <div
        class="flex items-center text-primary font-medium text-sm"
      >
        <span>{{ this.lang("lbl_0000309") }}</span>
        <svg
          class="w-4 h-4 ml-1"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  name: "services-card-control",
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    href: { type: String, default: "/" },
    eft: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
div {
  transition: border-color 0.3s ease;
}
div:hover {
  border-color: #d1d5db;
}
.text-primary {
  color: #016b00;
}
</style>
